"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";

/**
 * Hook to detect if the current viewport is mobile
 * @param breakpoint The width in pixels to consider as the mobile breakpoint (default: 768 for 'md')
 * @returns boolean true if the viewport is smaller than the breakpoint
 */
export const useIsMobile = t0 => {
  const $ = _c(3);
  const breakpoint = t0 === undefined ? 768 : t0;
  const [isMobile, setIsMobile] = useState(false);
  let t1;
  let t2;
  if ($[0] !== breakpoint) {
    t1 = () => {
      const checkIsMobile = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
      checkIsMobile();
      window.addEventListener("resize", checkIsMobile);
      return () => window.removeEventListener("resize", checkIsMobile);
    };
    t2 = [breakpoint];
    $[0] = breakpoint;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return isMobile;
};